export const radius = {
  pill: '100px',
  none: '0px', // this has the same effect as '50%';
  xxs: '10px',
  xs: '20px',
  card: '4px',
};
